import APIServiceLookUp from './serviceAPI';
import { API_URL } from './models/AppConstent';

export default class ServiceEnrollment {
    lookupService = new APIServiceLookUp();

    async getAllEnrollments(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}enrollment/getAllEnrollments`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }

    async updateEnrollment(body, token) {
        var serviceType = "POST";
        var url = `${API_URL}enrollment/updateEnrollment`;
        var apiService = this.lookupService.getAPIService(serviceType);
        return await apiService.doCall(url, body, token);
    }
}